
            import "data:text/css,.m-timeInfo-d33f348838%7Btext-align:center;position:fixed;bottom:0;left:0;height:auto;margin-bottom:3em;margin-left:3em;font-weight:600%7D.m-timeLabel-d33f348838%7Bcolor:#72727d;padding-right:0.5em%7D";
            const result = {"timeInfo":"m-timeInfo-d33f348838","timeLabel":"m-timeLabel-d33f348838"};
            export default result;
          